import { useState } from 'react';

import ImportacaoIndicesProjecao from '../../components/ImportacaoIndicesProjecao/ImportacaoIndicesProjecao';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function IndicesProjecaoImportacao() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <ImportacaoIndicesProjecao  setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}